import service from '@/utils/request'
// 查询币种
export function basicCurrencyList(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/basicCurrencyList',
        data: param
    })
}
// 查询币种 不分页
export function basicCurrencyListAll() {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/list',
    })
}
// 新增币种
export function addBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/add',
        data: param
    })
}
// 修改币种
export function editBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/edit',
        data: param
    })
}

// 批量删除币种
export function batchDelBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/batchDel',
        data: param
    })
}



// 删除币种
export function delBasicCurrency(param) {
    return service.request({
        method: 'POST',
        url: '/app/basicCurrency/del',
        data: param
    })
}
